import { RoleDataResponse } from '../auth-role/auth-role.types';
import { BaseResponseType } from '../cognito/authResponse.types';
import { UserType } from '../cognito/user.types';
import { UserRestaurantsType } from '../employee/userRestaurants.types';
import { RecordStatus } from '../menu/enums.types';
import { UserBusinessRestaurantType, UserPermissionType } from '../public/enum.types';

export enum SalaryType {
  FIXED = 'fixed',
  HOURLY = 'hourly',
}

//new
export enum EmployeePayTypeEnum {
  FIXED = 'Fixed',
  HOURLY = 'Hourly',
}

export enum FixedSalaryPeriod {
  YEAR = 'Year',
  MONTH = 'Month',
  TWO_WEEKS = '2-Weeks',
  WEEK = 'Week',
}

export interface UserRolesRequestType {
  id?: number;
  roleId: number;
  salary: number;
  payType: EmployeePayTypeEnum;
  fixedPeriod?: FixedSalaryPeriod;
}

export interface UserRolesDataResponse {
  id: number;
  userRestaurant: UserRestaurantsType;
  role: RoleDataResponse;
  deactivatedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface UserAllowFeatures {
  roleId: number;
  roleName: string;
  allowedFeatures: AllowedFeaturesModuleType;
}

export interface AllowedFeaturesModuleType {
  featureId: number;
  featureName: string;
  moduleName: string;
  approvalNeeded: string;
  isVisible: string;
}
export interface UserAllowModules {
  moduleId: number;
  moduleName: string;
}
export enum UserRoleType {
  SUPER_ADMIN = 'super-admin',
  OPERATION = 'operation',
  AIO_BUDDY = 'aio-buddy',
  OWNER = 'owner',
  MANAGER = 'manager',
  SERVER = 'server',
  COOK = 'cook',
  BARTENDER = 'bartender',
  CASHIER = 'cashier',
  BUSSER = 'busser',
  DELIVERY_SERVICE_DRIVER = 'delivery-service-driver',
  LINE_COOK = 'line-cook',
  SHIFT_OR_ASSISTANT_MANAGER = 'shift-or-assistant-manager',
  BARBACK = 'barback',
  GM = 'gm',
  CHEF = 'chef',
  DISH_WASHER = 'dish-washer',
  JANITORIAL = 'janitorial',
  ACCOUNTANT = 'accountant',
}
//----------------Operation-------------------------//
export interface Operation {
  firstName: string;
  lastName: string;
  email: string;
  contactNo: string;
  id?: string;
  userType?: UserType;
}

export interface OperationModulePermission {
  id: number;
  featureId: number;
  appId: number;
  moduleId: number;
  name: string;
  value: boolean;
  key: string;
}

//---------------AIO Buddy--------------------------//

export interface AioBuddy {
  firstName: string;
  lastName: string;
  email: string;
  contactNo: string;
  id?: string;
  businesses?: number[];
  restaurants?: number[];
  userType?: UserType;
}

// Define interface for modulePermission
export interface ModulePermission {
  id: number;
  value: boolean;
  label: string;
  key: string;
  appId: number;
  appKey: string;
}

// Define interface for location
export interface Location {
  id: number;
  label: string;
  value: boolean;
}

// Define interface for selectedBusinessPermissions
export interface SelectedBusinessPermission {
  value: number;
  label: string;
  location: Location[];
}

// Define interface for the main JSON object
export interface AioBuddyData {
  aioBuddy: AioBuddy;
  modulePermission: ModulePermission[];
  selectedBusinessPermissions: SelectedBusinessPermission[];
  restaurantId: number;
}

export interface UserPermissionInterface {
  userId: string;
  permissionId: number;
  appId: number;
  moduleId: number;
  key: string;
  isGranted: boolean;
  status: RecordStatus;
  type: UserPermissionType;
}
export interface UserBusinessRestaurant {
  businessId: number;
  type: UserBusinessRestaurantType;
  userId: string;
  restaurantId: number;
}

export interface BusinessWithRestaurants {
  value: number;
  label: string;
  location: Restaurant[];
}

export interface Restaurant {
  id: number;
  label?: string;
  value?: boolean;
}
export interface ModulePermissionInfo {
  id: number;
  label: string;
  key: string;
  appId: number;
  appKey: string;
}

export interface AioBuddyResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  contactNo: string;
  status: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  deletedAt: Date | null;
  createdBy: string | null;
  updatedBy: string | null;
  deletedBy: string | null;
}

// Interface for userBusinessData item
export interface UserBusinessDataItem {
  id: number;
  userId: string;
  restaurantId: number;
  businessId: number;
  type: string;
}

// Interface for userPermission item
export interface UserPermissionItem {
  id: number;
  roleId: number | null;
  userId: string;
  permissionId: number;
  appId: number;
  moduleId: number;
  featureId: number | null;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: string;
  type: string;
  status: string;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  deletedAt?: Date | null;
  createdBy?: string | null;
  updatedBy?: string | null;
  deletedBy?: string | null;
}

// Define the entire data structure
export interface AioBuddyResponseData {
  aioBuddy: AioBuddyResponse;
  userBusinessData: UserBusinessDataItem[];
  userPermission: ModulePermissionInfo[];
}

export interface AioBuddyGetItem {
  firstName: string;
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AioBuddyGetResponse {
  aiobuddy: AioBuddyGetItem[];
}

export interface StaticAioBuddyData {
  permissionData: ModulePermissionInfo[];
  restaurantLocation: BusinessWithRestaurants[];
}

export interface GetAIoBuddyStaicDataResponse {
  data: StaticAioBuddyData;
  success: boolean;
  message: string;
  error?: string | null;
}
export interface UserRoleTypes {
  userRestaurantId: number;
  userId: string;
  roleId: number;
  salary: number;
  payType: EmployeePayTypeEnum;
  fixedPeriod?: FixedSalaryPeriod;
  isDefault?: boolean;
}

export interface UserRolesBasicTypes {
  id?: number;
  salary?: number;
  payType?: EmployeePayTypeEnum;
  fixedPeriod?: FixedSalaryPeriod;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: Date;
  updatedBy?: Date;
  deactivatedAt?: Date;
  isDefault?: true;
}

export interface RolesBasicType {
  id?: number;
  name?: string;
  key?: string;
  tag?: string[];
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: Date;
  updatedBy?: Date;
  status?: boolean;
  userPermissions?: UserPermissionItem[];
}

export interface UserRoleRelationsType extends UserRolesBasicTypes {
  role?: RolesBasicType;
}

export interface IUserRolesRequest {
  userRestaurantId: number;
  roleId: number;
  salary: number;
  payType: EmployeePayTypeEnum;
  fixedPeriod?: FixedSalaryPeriod;
}

export interface IUserRolesRequestType {
  roleId: number | null;
  salary: number;
  payType: EmployeePayTypeEnum;
  fixedPeriod?: FixedSalaryPeriod;
}

export interface IDeleteEmployeeRoles {
  restaurantId: number;
  employeeId: string;
}
export interface Options {
  value: number;
  label: string;
  subLabel?: string;
  times?: { startTime?: string; endTime?: string }[];
}

export interface OperationFormData {
  item?: {
    firstName: string;
    lastName: string;
    email: string;
    contactNo?: string;
    id?: number;
  };
  restaurantPermissionData?: Options[];
  locationPermissionData?: Options[];
}

export interface StaticFormData {
  restaurantPermission: Options[];
  locationPermission: Options[];
}

export interface OperationData {
  operations: {
    firstName: string;
    lastName: string;
    email: string;
    contactNo?: string;
    id?: number;
  };
  selectedRestaurantPermissions: Options[] | undefined;
  selectedLocationPermissions: Options[] | undefined;
  restaurantId?: number;
}

export interface restaurantLocationPermissions {
  id?: number;
}

//----------------MoM APP-------------------------//
export enum ActionKeyEnums {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  Visible = 'visible',
}

export interface IndividualFeatureType {
  id?: number;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  status?: boolean;
}
export interface FeatureType extends IndividualFeatureType {
  action: string[] | null;
}

export interface PermissionResponseDataType extends IndividualFeatureType {
  features: FeatureType[] | null;
  modulePermission: string[] | null;
}
export interface PermissionResponseType extends BaseResponseType {
  data: PermissionResponseDataType[];
}
